var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineAsMultiThreshold1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 17.868C14.345 17.868 17.8675 14.3455 17.8675 10.0004C17.8675 5.65524 14.345 2.13281 9.9999 2.13281C5.65475 2.13281 2.13232 5.65524 2.13232 10.0004C2.13232 14.3455 5.65475 17.868 9.9999 17.868Z",
    stroke: "#3765DC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6416 9.9987L7.3066 9.99871M7.3066 9.99871L7.3066 8.33203M7.3066 9.99871L7.3066 11.6654M7.3066 9.99871H8.9716",
    stroke: "#3765DC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4395 7.02734L12.4395 12.9701",
    stroke: "#3765DC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineAsMultiThreshold1);
export default __webpack_public_path__ + "static/media/timeline-as-multi-threshold1.2552daf5285310ed6e9489a1384b8870.svg";
export { ForwardRef as ReactComponent };